import axiosInstance from "./axiosInstance";

let api = axiosInstance()

  export const getCandidateAvailability = async(id, abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/MISRreports/CandidateAvailability/${id}`, config)
  }

  export const getEmployerAvailability = async(id, abortToken)=>{
    const config = {
        ...abortToken,
        timeout: 30000, // Set the timeout for this specific request
      };
    return  await api.get(`/MISRreports/EmployerAvailability/${id}`, config)
  }